import { useToastStore } from '../../store/toast-store';

export const useToast = () => {
  const add = useToastStore(state => state.add);
  return {
    add,
  };
};
